import { object, string } from "yup";

export const getEmployersInputs = (t) => [
  {
    name: "employerName",
    label: t("employers.fields.employerName.label"),
    type: "text",
    placeholder: t("employers.fields.employerName.placeholder"),
  },
  {
    name: "employerPhone",
    label: t("employers.fields.employerPhone.label"),
    type: "text",
    placeholder: t("employers.fields.employerPhone.placeholder"),
  },
  {
    name: "startDate",
    label: t("employers.fields.startDate.label"),
    type: "date",
    placeholder: t("employers.fields.startDate.placeholder"),
  },
  {
    name: "endDate",
    label: t("employers.fields.endDate.label"),
    type: "date",
    placeholder: t("employers.fields.endDate.placeholder"),
  },
  {
    name: "employerAddress1",
    label: t("employers.fields.employerAddress1.label"),
    type: "text",
    placeholder: t("employers.fields.employerAddress1.placeholder"),
  },
  {
    name: "employerAddress2",
    label: t("employers.fields.employerAddress2.label"),
    type: "text",
    placeholder: t("employers.fields.employerAddress2.placeholder"),
  },
  {
    name: "employerCity",
    label: t("employers.fields.employerCity.label"),
    type: "text",
    placeholder: t("employers.fields.employerCity.placeholder"),
  },
  {
    name: "employerState",
    label: t("employers.fields.employerState.label"),
    type: "text",
    placeholder: t("employers.fields.employerState.placeholder"),
  },
  {
    name: "employerZip",
    label: t("employers.fields.employerZip.label"),
    type: "text",
    placeholder: t("employers.fields.employerZip.placeholder"),
  },
  {
    name: "supervisorName",
    label: t("employers.fields.supervisorName.label"),
    type: "text",
    placeholder: t("employers.fields.supervisorName.placeholder"),
  },
  {
    name: "jobTitle",
    label: t("employers.fields.jobTitle.label"),
    type: "text",
    placeholder: t("employers.fields.jobTitle.placeholder"),
  },
  {
    name: "startRate",
    label: t("employers.fields.startRate.label"),
    type: "text",
    placeholder: t("employers.fields.startRate.placeholder"),
  },
  {
    name: "endRate",
    label: t("employers.fields.endRate.label"),
    type: "text",
    placeholder: t("employers.fields.endRate.placeholder"),
  },
  {
    name: "jobDuties",
    label: t("employers.fields.jobDuties.label"),
    type: "text",
    placeholder: t("employers.fields.jobDuties.placeholder"),
  },
  {
    name: "reasonForLeaving",
    label: t("employers.fields.reasonForLeaving.label"),
    type: "text",
    placeholder: t("employers.fields.reasonForLeaving.placeholder"),
  },
];

export const getValidationSchema = (t) =>
  object().shape({
    employerName: string()
      .required(t("employers.validation.employerNameRequired"))
      .min(2, t("employers.validation.employerNameMin"))
      .max(100, t("employers.validation.employerNameMax")),
    employerPhone: string().required(t("employers.validation.phoneRequired")),
    startDate: string().required(t("employers.validation.startDateRequired")),
    employerAddress1: string().required(
      t("employers.validation.addressRequired")
    ),
    employerCity: string().required(t("employers.validation.cityRequired")),
    employerState: string()
      .required(t("employers.validation.stateRequired"))
      .max(2, t("employers.validation.stateIdentifier"))
      .matches(
        /^([A-Za-zÀ-ÖØ-öø-ÿ\s]*)$/gi,
        t("employers.validation.stateLettersOnly")
      ),
    employerZip: string().required(t("employers.validation.zipRequired")),
    supervisorName: string().required(
      t("employers.validation.supervisorNameRequired")
    ),
    jobTitle: string().required(t("employers.validation.jobTitleRequired")),
    startRate: string().required(t("employers.validation.startRateRequired")),
    jobDuties: string().required(t("employers.validation.jobDutiesRequired")),
  });
